// extracted by css-extract-rspack-plugin
module.exports =  {"root":"TextMessageContent__root___pcxkr"};